import { call, put, takeEvery } from 'redux-saga/effects';
import toast from 'react-hot-toast';
import { postApiRequest } from '../../../../features/axiosClient';
import { GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL } from '../../../../constants/ApiUrlConstants';
import {
  getLegalTemplateFormFieldDetailsFailure,
  getLegalTemplateFormFieldDetailsSuccess,
} from '../actions/slateDataActions';
import { GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST } from '../../../../constants/ActionNameConstants';

const getLegalTemplateFormFieldDetails = (action) =>
  postApiRequest(`${GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_API_URL}`, {
    audioFileId: action.audioFileId,
    legalTemplateName: action.legalTemplateName.toString(),
    cgaType: action.cgaType || undefined,
  });

function* fetchLegalTemplateFormFieldDetailsSaga(action) {
  try {
    const response = yield call(getLegalTemplateFormFieldDetails, action.payload);
    if (response?.data?.errorMessage !== '' && !response.data?.success) {
      toast.error(response?.data?.errorMessage);
    }
    const jsonResponse = JSON.parse(response.data.value);
    yield put(getLegalTemplateFormFieldDetailsSuccess(jsonResponse));
  } catch (error) {
    yield put(getLegalTemplateFormFieldDetailsFailure(error.message));
  }
}

export function* watchFetchLegalTemplateFormFieldDetails() {
  yield takeEvery(GET_LEGAL_TEMPLATE_FORM_FIELD_DETAILS_REQUEST, fetchLegalTemplateFormFieldDetailsSaga);
}
